import React, { useEffect, useState } from "react";
import { collegeKulgeetApi } from "../../config/api";
import { apiClient } from "../../utils/apiClient";
import "./college-kulgeet.scss";

const defaultData = {
  _id: null, Title: "College Kulgeet", Description: "", Lyrics_Text: "", Upload_Audio_File: "", Upload_Video_File: "",
};

const CollegeKulgeet = () => {
  const [formData, setFormData] = useState(defaultData);
  const [loading, setLoading] = useState(false);
  const [saved, setSaved] = useState(false);

  useEffect(() => { fetchData(); }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await apiClient(collegeKulgeetApi);
      const result = await response.json();
      if (response.ok && result.data) {
        const fetchedData = Array.isArray(result.data) ? result.data[0] : result.data;
        if (fetchedData) {
          setFormData(fetchedData);
        }
      }
    } catch (error) {
      console.error("Error fetching Kulgeet data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      const method = formData._id ? "PUT" : "POST";
      const url = formData._id ? `${collegeKulgeetApi}/${formData._id}` : collegeKulgeetApi;
      const response = await apiClient(url, {
        method,
        body: JSON.stringify(formData),
      });
      if (response.ok) {
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);
        fetchData();
      }
    } catch (error) {
      console.error("Error saving Kulgeet data:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="kulgeet-page">
      <div className="kulgeet-page__header">
        <div><h1>College Kulgeet</h1><p>Manage the official anthem of the institution, including lyrics, audio recordings, and video presentations.</p></div>
        <button className="save-btn" type="submit" form="kulgeetForm" disabled={loading}>{loading ? "Saving..." : saved ? "✓ Saved" : "Save Anthem"}</button>
      </div>

      <form id="kulgeetForm" className="kulgeet-form" onSubmit={handleSubmit}>
        <div className="kulgeet-card">
          <div className="form-section-label">General Information</div>
          <div className="form-group"><label>Display Title</label><input type="text" name="Title" value={formData.Title} onChange={handleChange} placeholder="e.g. College Kulgeet" required /></div>
          <div className="form-group"><label>Anthem Introduction</label><textarea name="Description" rows="4" value={formData.Description} onChange={handleChange} placeholder="Brief introduction or significance of the Kulgeet..." /></div>

          <div className="form-section-label">Media Resources</div>
          <div className="form-row">
            <div className="form-group"><label>Audio URL</label><input type="text" name="Upload_Audio_File" value={formData.Upload_Audio_File} onChange={handleChange} placeholder="Enter official audio recording URL..." /></div>
            <div className="form-group"><label>Video URL</label><input type="text" name="Upload_Video_File" value={formData.Upload_Video_File} onChange={handleChange} placeholder="Enter official video presentation URL..." /></div>
          </div>
          
          <div className="media-preview-container">
            {formData.Upload_Audio_File && (
              <div className="preview-block"><label>Audio Preview</label><audio controls className="audio-preview" key={formData.Upload_Audio_File}><source src={formData.Upload_Audio_File} /></audio></div>
            )}
            {formData.Upload_Video_File && (
              <div className="preview-block"><label>Video Preview</label><video controls className="video-preview" key={formData.Upload_Video_File}><source src={formData.Upload_Video_File} /></video></div>
            )}
          </div>

          <div className="form-section-label">Official Lyrics</div>
          <div className="form-group"><label>Anthem Lyrics (Full Text)</label><textarea name="Lyrics_Text" rows="18" value={formData.Lyrics_Text} onChange={handleChange} placeholder="Enter the official lyrics of the college anthem here..." required /></div>
        </div>
      </form>
    </div>
  );
};

export default CollegeKulgeet;